import { render, staticRenderFns } from "./seat.vue?vue&type=template&id=b55649aa&scoped=true&"
import script from "./seat.vue?vue&type=script&lang=js&"
export * from "./seat.vue?vue&type=script&lang=js&"
import style0 from "./seat.vue?vue&type=style&index=0&id=b55649aa&prod&lang=scss&"
import style1 from "./seat.vue?vue&type=style&index=1&id=b55649aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55649aa",
  null
  
)

export default component.exports